import { MAX_HR_BPM, MIN_HR_BPM } from './constants';
import type { NnInterval } from './types';

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const hrToRrMs = (hrBpm: number): number | undefined => {
  if (!isFiniteNumber(hrBpm) || hrBpm < MIN_HR_BPM || hrBpm > MAX_HR_BPM) {
    return undefined;
  }
  return 60_000 / hrBpm;
};

export const deriveNnFromHr = (
  hrValues: Array<number | undefined>,
  timestamps: number[]
): NnInterval[] => {
  const nn: NnInterval[] = [];

  for (let index = 0; index < hrValues.length; index += 1) {
    const hr = hrValues[index];
    const timestamp = timestamps[index];
    if (!isFiniteNumber(timestamp)) continue;

    const rrMs = hrToRrMs(hr ?? NaN);
    if (rrMs === undefined) continue;

    nn.push({ timestamp, rrMs });
  }

  return nn;
};
